// extracted by mini-css-extract-plugin
export default {"richMediaCreativeDetailContainer":"richMediaCreativeDetail_richMediaCreativeDetailContainer__fUOSo"};